import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { getSessionStorage, setSessionStorage } from '../utils/storage.utils';

@Injectable({
  providedIn: 'root'
})
export class UtmHandlerService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private readonly UTM_STORAGE_KEY = 'utm_params';
  private utmParams = new BehaviorSubject<{[key: string]: string}>({});

  constructor() {
    this.loadFromStorage();
    this.captureFromUrl();
    this.persistOnNavigate(); // <-- NUEVA LÓGICA
  }

  private loadFromStorage(): void {
    const storedParams = getSessionStorage(this.UTM_STORAGE_KEY);
    if (storedParams) {
      this.utmParams.next(storedParams);
    }
  }

  private captureFromUrl(): void {
    this.route.queryParamMap.subscribe(params => {
      const currentParams = this.utmParams.getValue();
      const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'codasesor', 'gclid'];
      let newParamsFound = false;

      utmKeys.forEach(key => {
        if (params.has(key) && currentParams[key] !== params.get(key)) {
          currentParams[key] = params.get(key)!;
          newParamsFound = true;
        }
      });

      if (newParamsFound) {
        this.utmParams.next(currentParams);
        setSessionStorage(this.UTM_STORAGE_KEY, currentParams);
      }
    });
  }

  /**
   * ✅ Lógica clave: Escucha el final de cada navegación y, si es necesario,
   * añade los UTMs a la URL, reemplazando el historial para no romper
   * el botón de "atrás" del navegador.
   */
  private persistOnNavigate(): void {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      const storedUtms = this.utmParams.getValue();
      if (Object.keys(storedUtms).length === 0) {
        return; // No hay nada que persistir
      }

      const currentParams = this.route.snapshot.queryParams;
      const areParamsMissing = !Object.keys(storedUtms).every(
        key => currentParams[key] === storedUtms[key]
      );

      if (areParamsMissing) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: storedUtms,
          queryParamsHandling: 'merge', // Fusiona los UTM con cualquier otro parámetro existente
          replaceUrl: true // No crea una nueva entrada en el historial del navegador
        });
      }
    });
  }

  public getUtmParams(): {[key: string]: string} {
    return this.utmParams.getValue();
  }
}